var React = require('react');

function Angles (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M352,0,0,176.82H352Z","key":0}),React.createElement("path",{"d":"M701,0,349.05,176.82H701Z","key":1})]);
}

Angles.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 701 176.82"};

module.exports = Angles;

Angles.default = Angles;
